module.exports = __webpack_public_path__ + "img/dew.bdfc3982.jpg";